var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestimonials(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 7318,
    transform: "translate(-344 -5498)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddd_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -50,
    y: -219,
    width: 586,
    height: 343,
    rx: 40,
    fill: "#C17B31"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "url(#pattern0)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddd_0_1",
    x: -330,
    y: -279,
    width: 1234,
    height: 1536,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 51
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 55.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 11,
    dy: 202
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 101.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_0_1",
    result: "effect2_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 25,
    dy: 455
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 137
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_0_1",
    result: "effect3_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 44,
    dy: 809
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 162
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_0_1",
    result: "effect4_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_0_1",
    transform: "scale(0.00862069)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 7318,
    fill: "white",
    transform: "translate(-344 -5498)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    rx: 29,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_0_1",
    width: 116,
    height: 116,
    xlinkHref: "data:image/jpeg;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonials);
export default __webpack_public_path__ + "static/media/testimonials.2d4b41ef6d9b232ed4a09dda80eb58af.svg";
export { ForwardRef as ReactComponent };